<template>
  <div class="flex flex-col lg:flex-row lg:space-x-4">
    <div class="flex flex-col lg:w-2/5 justify-between py-8 lg:pr-4">
      <div class="space-y-4 text-left">
        <p class="text-4xl font-bold" v-html="$t('quiz.questionAB')"></p>
        <p class="uppercase" v-html="$t('quiz.select_picture')"></p>
      </div>

      <div class="flex flex-col space-y-4">
        <button
          class="button--answer"
          v-if="!showAnswer"
          @click="answer('a')"
        >
          A
        </button>
        <button
          class="button--answer"
          v-if="!showAnswer"
          @click="answer('b')"
        >
          B
        </button>
        <div
          class="alert"
          v-if="showAnswer"
          :class="{
            'alert--correct': correct,
            'alert--wrong': !correct,
          }"
        >
          <transition name="fade">
            <p v-if="correct" v-html="$t('quiz.correct')"></p>
            <p v-else v-html="$t('quiz.wrong')"></p>
          </transition>
        </div>
      </div>
    </div>
    <div class="lg:w-3/5">
      <div class="flex flex-row space-x-3">
        <div
          :class="{
            'shadow-[0_0_0_4px] shadow-green': showAnswer && correct,
          }"
        >
          <img :src="`/sites/msd_gesundheit/themes/custom/melanoma/assets/quiz/de/images/${$i18n.locale}/${questionImageA}`" alt="Melanoma QUIZ image" />
        </div>
        <div
          :class="{
            'shadow-[0_0_0_4px] shadow-red': showAnswer && !correct,
          }"
        >
          <img :src="`/sites/msd_gesundheit/themes/custom/melanoma/assets/quiz/de/images/${$i18n.locale}/${questionImageB}`" alt="Melanoma QUIZ image" />
        </div>
      </div>
      <div
        class="flex flex-row space-x-3 post-it mt-3"
        :class="{
          invisible: !showAnswer,
        }"
      >
        <transition name="fade">
          <p v-if="correct" v-html="$t('quiz.questionAB_correct')"></p>
          <p v-if="!correct" v-html="$t('quiz.questionAB_wrong')"></p>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QuestionAB",
  props: {
    questionImageA: String,
    questionImageB: String,
    correct: Boolean,
    showAnswer: Boolean,
  },
  data() {
    return {
      selectedAnswer: "",
    };
  },
  methods: {
    answer(value) {
      this.selectedAnswer = value;
      this.$emit("answer", value);
    },
  },
};
</script>

<style scoped lang="scss">
.button--answer {
  color: #000;
  font-size: 1.125rem;
  font-weight: 500;
  text-transform: uppercase;
  border: 1px solid #000;
  border-radius: 5px;
  padding: 1rem 1.5rem;
}

.alert {
  position: relative;
  padding: 1rem 1rem;
  background-color: var(--clr-gray-100);
  border-radius: 5px;
  color: #fff;
  font-size: 1.125rem;
  font-weight: 700;

  &--correct {
    background-color: var(--clr-green);
  }
  &--wrong {
    background-color: var(--clr-red);
  }
}
</style>
